export const SYSTEM_ORGS = [
  '7A937E99-5A62-4FCC-865A-000000000001',
  '7A937E99-5A62-4FCC-865A-000000000002',
];

export const isSystemOrganisation = orgId =>
  Boolean(orgId && SYSTEM_ORGS.find(so => so.toLowerCase() === orgId.toLowerCase()));
